import ScoopLogo from '../../../../assets/common/NewLogo.svg'
import { ScoopText, ScoopColumn, ScoopRow } from '../../../ui'
import { PlusIcon, ShapesIcon } from '@phosphor-icons/react'
import { WorkspaceBox } from './WorkspaceBox/WorkspaceBox'
import styles from './CreateWorkspace.module.scss'

export const CreateWorkspace = ({ selectOption }) => {
    const handleOptionClick = (option) => {
        if (option === 0) localStorage.setItem('redirectTour', 'true')
        selectOption(option)
    }

    return (
        <ScoopColumn className={styles.container}>
            <ScoopColumn className={styles.headerSection}>
                <img src={ScoopLogo} alt="Scoop Logo" className={styles.logo} />
                <ScoopColumn className={styles.titleSection}>
                    <ScoopText className={styles.title}>
                        Great, how would you like to begin?
                    </ScoopText>
                </ScoopColumn>
            </ScoopColumn>
            <ScoopRow className={styles.optionsContainer}>
                <WorkspaceBox
                    onClick={() => handleOptionClick(0)}
                    icon={<PlusIcon size={32} weight="regular" className={styles.icon} />}
                    title={'Start working freely'}
                    subtitle={'Create a blank Workspace and explore your data in your own way'}
                />
                <WorkspaceBox
                    onClick={() => handleOptionClick(1)}
                    icon={<ShapesIcon size={32} weight="regular" className={styles.icon} />}
                    title={'Start with a recipe'}
                    subtitle={
                        'Get inspired with one of our recipes. Simply connect your data and see it come to life in pre-made canvases'
                    }
                />
            </ScoopRow>
        </ScoopColumn>
    )
}
